import { AppHeaderAccount as View } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'
import { useGetUserByIdQuery } from '~header/services/user'

const Account = () => {
  const { user, authenticated, loading, initialized } = useAuth()
  const { gotoSignInPage, gotoSignUpPage, signOut } = useFederatedAuth()

  const {
    isLoading: isGetUserByIdLoading,
    workspaces,
    defaultWorkspaceId
  } = useGetUserByIdQuery(
    { byUserId: user?.id },
    {
      refetchOnMountOrArgChange: true,
      selectFromResult: (state) => {
        const { isLoading, data } = state

        const { defaultWorkspaceId, membershipCollection } =
          data?.getUserById || {}

        return {
          isLoading,
          defaultWorkspaceId,
          workspaces: membershipCollection?.items?.map((item) => item.workspace)
        }
      }
    }
  )

  const handleSignInClick = () => {
    gotoSignInPage({ postSignIn: '/search' })
  }

  const handleSignUpClick = () => {
    gotoSignUpPage({ postSignUp: '/search' })
  }

  const handleSignOutClick = () => {
    signOut({ preventRedirect: true })
  }

  const isLoading = !initialized || loading || isGetUserByIdLoading

  return (
    <View
      loading={isLoading}
      authenticated={authenticated}
      user={user}
      workspaces={workspaces}
      defaultWorkspaceId={defaultWorkspaceId}
      onSignInClick={handleSignInClick}
      onSignUpClick={handleSignUpClick}
      onSignOutClick={handleSignOutClick}
    />
  )
}

export { Account }
